import { type KeyboardEvent } from 'react'
import { observer } from 'mobx-react-lite'
import { type Observable } from 'rxjs'
import { type BoolQuestionAnswerEditorViewModel } from '@/features/jobs/questions/bool/BoolQuestionAnswerEditorViewModel'
import { BoolQuestionAnswerEditor } from '@/features/jobs/questions/bool/components/BoolQuestionAnswerEditor'

export interface BoolQuestionAnswerEditorContainerProps {
  editorVm: BoolQuestionAnswerEditorViewModel
  questionId: string
  isDisabled: boolean
  focus$?: Observable<unknown>
  onFocus?: () => unknown
  onEnterDown?: (e: KeyboardEvent) => unknown
  isNotValid?: boolean
}

export const BoolQuestionAnswerEditorContainer = observer(
  function BoolQuestionAnswerEditorContainer({
    editorVm,
    questionId,
    ...rest
  }: BoolQuestionAnswerEditorContainerProps) {
    return (
      <BoolQuestionAnswerEditor
        value={editorVm.value}
        onChange={editorVm.respond}
        yesTestId={`bool-answer-yes-${questionId}`}
        noTestId={`bool-answer-no-${questionId}`}
        {...rest}
      />
    )
  },
)
